import request from "../../../utils/wapRequest";
const url = process.env.VUE_APP_BASE_API_V2;
const BASE_URL = process.env.VUE_APP_BASE_LOGIN;

const TeeTimeResource = {
  getListCategoryPax(query) {
    return request({
      url: `${BASE_URL}/services/get_list_categorys`,
      method: "GET",
      params: query
    });
  },
  getListPaxByCategory(query) {
    return request({
      url: `${BASE_URL}/services/get_list_booking_category`,
      method: "GET",
      params: query
    });
  },

  getOTPOrderBookingFast(data) {
    return request({
      url: `${url}/booking_order_for_web/get_otp_booking_order_for_web`,
      method: "POST",
      data
    });
  },
  orderBookingFast(data) {
    return request({
      url: `${url}/booking_order_for_web/request_booking_order_for_web`,
      method: "POST",
      data
    });
  },

  historyBooked(params) {
    return request({
      url: `${BASE_URL}/services/get_list_general_bill_for_wap`,
      method: "GET",
      params
    });
  },
  historyBookedOld(data) {
    return request({
      url: `${BASE_URL}/services/get_list_general_bill_for_bank`,
      method: "POST",
      data
    });
  },
  listOrderBooked(params) {
    return request({
      url: `${BASE_URL}/services/get_list_order`,
      method: "GET",
      params
    });
  },

  create_booking_for_wap(data) {
    return request({
      url: `${BASE_URL}/services/create_delivery_for_wap`,
      method: "POST",
      data
    });
  }
};
export { TeeTimeResource as default };
